/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';

import { Button, Slider, Divider, Stack } from '@mui/material';

import { Typography } from 'components/atoms/Typography';
import { HiddenStates, MarkerData, StateData, StateGroupData } from 'types/map';

import { MapEditor } from './mapEditor';

export type MapConfig = {
    states?: StateData[];
    groups?: StateGroupData[];
    hidden?: HiddenStates;
    markers?: MarkerData[];
    height?: number;
    markerScale?: number;
};

type MapConfigCreatorProps = {
    defaultConfig?: MapConfig;
    onSave?: (config: MapConfig) => void;
};

const markerssMap = [
    {
        value: 220,
        label: 'Маленькая',
    },
    {
        value: 320,
        label: 'Средняя',
    },
    {
        value: 420,
        label: 'Большая',
    },
];

const valuetext = (value: number): string => {
    return `${value}`;
};
export const MapConfigCreator = ({
    defaultConfig,
    onSave = () => undefined,
}: MapConfigCreatorProps): JSX.Element => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button variant="outlined" onClick={() => setOpen(true)}>
                Настроить карту
            </Button>
            <Divider />
            <Typography>Размер карты</Typography>
            <Stack sx={{ px: 1 }} direction="row" spacing={1}>
                <Slider
                    getAriaValueText={valuetext}
                    min={markerssMap[0].value - 50}
                    max={markerssMap.slice(-1)[0].value + 50}
                    step={50}
                    valueLabelDisplay="auto"
                    value={defaultConfig?.height}
                    marks={markerssMap}
                    onChange={(e, v) => {
                        onSave({
                            height: typeof v === 'number' ? v : undefined,
                        });
                    }}
                />
            </Stack>
            <Divider />
            <Typography>Размер маркеров</Typography>
            <Stack sx={{ px: 1 }} direction="row" spacing={1}>
                <Slider
                    min={0.5}
                    max={3}
                    step={0.2}
                    valueLabelDisplay="auto"
                    value={defaultConfig?.markerScale}
                    onChange={(e, v) => {
                        onSave({
                            markerScale: typeof v === 'number' ? v : undefined,
                        });
                    }}
                />
            </Stack>
            <Divider />
            <MapEditor
                defaultConfig={defaultConfig}
                onClose={() => setOpen(false)}
                onSave={(temp) => {
                    setOpen(false);
                    onSave(temp);
                }}
                open={open}
            />
        </>
    );
};
